import type { LatLng, LocationFix } from "./types";
export interface SpeedRoad { id: string; name: string; geometry: LatLng[]; forwardKph: number | null; backwardKph: number | null }
export function currentSpeed(fix: LocationFix | null, now = Date.now()): number | null {
  return fix && now - fix.observedAt <= 10000 && now >= fix.observedAt - 1000 && fix.accuracy <= 25 && fix.speedMps !== null && Number.isFinite(fix.speedMps) && fix.speedMps >= 0 && fix.speedMps < 90 ? fix.speedMps * 3.6 : null;
}
/** Conservative geometric match. Unknown roads are candidates too; parallel roads and junctions suppress the limit. */
export function roadLimit(fix: LocationFix | null, roads: SpeedRoad[], now = Date.now()): {kph:number;name:string} | null {
  if (currentSpeed(fix, now) === null || !fix) return null;
  const scale = Math.cos(fix.lat * Math.PI / 180);
  const candidates = roads.flatMap(road => {
    let best = {distance:Infinity, forward:true, angle:Infinity};
    for (let i=1;i<road.geometry.length;i++) {
      const a=road.geometry[i-1], b=road.geometry[i];
      const ax=(a.lng-fix.lng)*111320*scale, ay=(a.lat-fix.lat)*111320;
      const dx=(b.lng-a.lng)*111320*scale, dy=(b.lat-a.lat)*111320, len=dx*dx+dy*dy;
      if (!len) continue;
      const t=Math.max(0,Math.min(1,-(ax*dx+ay*dy)/len));
      const distance=Math.hypot(ax+t*dx,ay+t*dy);
      const bearing=(Math.atan2(dx,dy)*180/Math.PI+360)%360;
      const angle=fix.heading===null?0:Math.abs(((fix.heading-bearing+540)%360)-180);
      if(distance<best.distance) best={distance,forward:angle<=90,angle:Math.min(angle,180-angle)};
    }
    if(best.distance>20 || best.angle>35) return [];
    const kph=fix.heading===null ? (road.forwardKph===road.backwardKph?road.forwardKph:null) : best.forward?road.forwardKph:road.backwardKph;
    return [{...best,kph,name:road.name,id:road.id}];
  }).sort((a,b)=>a.distance-b.distance);
  const first=candidates[0];
  if(!first || first.kph===null || candidates.some((c,i)=>i>0 && c.distance<first.distance+8 && c.id!==first.id)) return null;
  return {kph:first.kph,name:first.name};
}
